import { render, staticRenderFns } from "./card-compare-two-image.vue?vue&type=template&id=86fe8eb6&scoped=true&"
import script from "./card-compare-two-image.vue?vue&type=script&lang=js&"
export * from "./card-compare-two-image.vue?vue&type=script&lang=js&"
import style0 from "./card-compare-two-image.vue?vue&type=style&index=0&id=86fe8eb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86fe8eb6",
  null
  
)

export default component.exports